<template>
  <g>
    <path d="M9 1L1 9L9 17" stroke="#252525" stroke-width="2" stroke-linejoin="round" fill="transparent" />
  </g>
</template>
